import { Link } from 'react-router-dom'
import { ExternalLinkIcon } from 'lucide-react'

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { ROUTES } from '@/lib/routes'

export function NavFooter() {
  const footerRoutes = Object.values(ROUTES).filter(
    route => route.section === 'footer',
  )

  if (footerRoutes.length === 0) return null

  return (
    <SidebarGroup>
      <SidebarMenu>
        {footerRoutes.map(item => {
          const isExternal = item.path.startsWith('http')

          return (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton asChild tooltip={item.title}>
                {isExternal ? (
                  <a
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center"
                  >
                    <item.icon className="ml-1" />
                    <span className="flex-1">{item.title}</span>
                    <ExternalLinkIcon className="h-3 w-3 opacity-50" />
                  </a>
                ) : (
                  <Link to={item.path!}>
                    <item.icon className="ml-1" />
                    <span>{item.title}</span>
                  </Link>
                )}
              </SidebarMenuButton>
            </SidebarMenuItem>
          )
        })}
      </SidebarMenu>
    </SidebarGroup>
  )
}
